// apps/account-portal/src/components/PageTitle.tsx
import React from 'react';

interface PageTitleProps {
  title: string;
  subtitle?: string;
  className?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, subtitle, className = '' }) => (
  <div className={`mb-6 ${className}`}>
    <h1 className={`text-2xl font-semibold text-[var(--text-primary)] ${subtitle ? 'mb-2' : ''}`}>{title}</h1>
    {subtitle && <p className="text-[var(--text-secondary)]">{subtitle}</p>}
  </div>
);

export default PageTitle;
